firebird.controller('meetingLockedCtrl', [
    '$window',
    'meetingService',
    function ($window, meetingService) {
        var self = this;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.meeting = meetingService.getCurrentMeeting();
        self.refresh = refresh;

        function refresh() {
            $window.location.reload();
        }
    }
]);
